/**
 * How a requested test is named on screen (D216, D220): the work-order
 * service's own frozen name in the interface language (falling back to the
 * other when only one was recorded), and its reference standard and version.
 * Never a price, a quantity or a discount — this is technical information
 * about a sample, not commercial scope.
 */

/** The service's name in `locale`, or the other language's when that is all there is. */
export function requestedTestName(
  ar: string | null,
  en: string | null,
  locale: string,
): string | null {
  return (locale === 'ar' ? (ar ?? en) : (en ?? ar)) ?? null;
}

/** "ASTM C136 2019", or null when the service names no standard. */
export function requestedTestStandard(
  referenceStandard: string | null,
  standardVersion: string | null,
): string | null {
  if (!referenceStandard) return null;
  return [referenceStandard, standardVersion].filter(Boolean).join(' ');
}

/** "Sieve Analysis — ASTM C136": one line, as the receiving card lists it. */
export function requestedTestLabel(
  name: string | null,
  standard: string | null,
  fallback: string,
): string {
  const shown = name ?? fallback;
  return standard ? `${shown} — ${standard}` : shown;
}
